import { useContext } from "react";
import { IReportInfo } from "../../../../models";
import { TimeUtils } from "../../../../utils";
import { AvisSection, AvisValueRow } from "../../../shared/components/form";
import { AvisContext } from "../../../shared/context/AvisContext";

interface ILicenseReportHeaderProps<T> {
  data: IReportInfo<T> | undefined;
}
export function LicenseReportHeader<T>(
  props: Readonly<ILicenseReportHeaderProps<T>>,
) {
  const { data } = props;
  const { res } = useContext(AvisContext);
  const col1 = 6;
  const col2 = 6;

  return (
    <AvisSection classNameIn="license-report-details">
      <AvisValueRow
        rowTitle={res("licensees_LicenseReports_header_label_ForLicense")}
        rowValue={data?.licenseNumber}
        rowTitleCols={col1}
        rowValueCols={col2}
      />
      <AvisValueRow
        rowTitle={res("label_ReportPeriod")}
        rowValue={TimeUtils.formatPeriod(data?.periodFrom, data?.periodTo)}
        rowTitleCols={col1}
        rowValueCols={col2}
      />
      <AvisValueRow
        rowTitle={res("licensees_LicenseReports_header_label_Status")}
        rowValue={data?.portalReportStatusType?.shortName}
        rowTitleCols={col1}
        rowValueCols={col2}
      />
      {data?.portalReportStatusType?.value === "Rejected" && (
        <AvisValueRow
          rowTitle={res("label_RejectReason")}
          rowValue={data?.rejectedReason}
          rowTitleCols={col1}
          rowValueCols={col2}
        />
      )}
    </AvisSection>
  );
}
